import ufeApi from 'services/api/ufeApi';
import locationUtils from 'utils/Location';

function challengeMessage(token, body) {
    const sdnApiHost = Sephora.configurationSettings.sdnApiHost;
    const gamificationMessageType = Sephora.configurationSettings.gamificationMessageType || 'GameStatus';
    const params = locationUtils.isPreviewEnvironment() ? '?isPreview=true' : '';
    const url = `${sdnApiHost}/v1/message/${gamificationMessageType}${params}`;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then(data => data);
}

export default { challengeMessage };
